export const NO_MATCHING_RESOURCE_SYMBOL = '-'

export const EMPTY_VALUE = 'EMPTY_VALUE'
